import { createContext, useContext } from 'react';

export const PlayerManagerContext = createContext<{
    toggleFullscreen: () => void;
}>({
    toggleFullscreen: () => {},
});

export const usePlayerManagerContext = () => useContext(PlayerManagerContext);
